export function countPossibleDuplicatePlayers(players = [], excludedPlayerIds = []) {
  const excluded = new Set(excludedPlayerIds);
  const candidates = players.filter((player) => !excluded.has(player.id));

  const normalize = (value) =>
    String(value || "")
      .split("#", 1)[0]
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const similarity = (a, b) => {
    if (!a.length && !b.length) return 1;
    if (!a.length || !b.length) return 0;

    const previous = Array.from({ length: b.length + 1 }, (_, i) => i);

    for (let i = 1; i <= a.length; i += 1) {
      let diagonal = previous[0];
      previous[0] = i;

      for (let j = 1; j <= b.length; j += 1) {
        const old = previous[j];
        previous[j] = Math.min(
          previous[j] + 1,
          previous[j - 1] + 1,
          diagonal + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        diagonal = old;
      }
    }

    return 1 - previous[b.length] / Math.max(a.length, b.length);
  };

  const matched = new Set();

  for (let i = 0; i < candidates.length; i += 1) {
    const left = normalize(candidates[i].activision_id);
    if (left.length < 3) continue;

    for (let j = i + 1; j < candidates.length; j += 1) {
      const right = normalize(candidates[j].activision_id);
      if (right.length < 3) continue;

      if (similarity(left, right) >= 0.8) {
        matched.add(candidates[i].id);
        matched.add(candidates[j].id);
      }
    }
  }

  return matched.size;
}
